module.exports = __webpack_public_path__ + "static/media/kiera-knightly-icon.8775d08b.jpg";